import { API_BASE } from '@/utils/api-url'

const CLIENT_ID = import.meta.env.VITE_APP_CLIENT_ID || 'app'
const CLIENT_SECRET = import.meta.env.VITE_APP_CLIENT_SECRET || 'app'

async function requestApp(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, options)
  const result = await response.json()
  if (!response.ok || result.code !== 0) {
    throw new Error(result.msg || '接口请求失败')
  }
  return result.data
}

function basicAuthHeader() {
  return `Basic ${btoa(`${CLIENT_ID}:${CLIENT_SECRET}`)}`
}

export async function loginWithPassword(phone, password) {
  const body = new URLSearchParams()
  body.set('grant_type', 'app_password')
  body.set('mobile', phone)
  body.set('password', password)

  const response = await fetch(`${API_BASE}/oauth2/token`, {
    method: 'POST',
    headers: {
      Authorization: basicAuthHeader(),
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body
  })

  const result = await response.json()
  if (!response.ok) {
    throw new Error(result.error_description || result.msg || '登录失败')
  }

  const tokenResponse = result?.access_token || result?.accessToken ? result : result?.data
  const accessToken = tokenResponse?.access_token || tokenResponse?.accessToken
  if (typeof accessToken !== 'string' || !accessToken.trim()) {
    throw new Error('登录响应缺少访问令牌')
  }

  return {
    ...tokenResponse,
    access_token: accessToken.trim()
  }
}

export async function sendLoginCode(phone) {
  const response = await fetch(`${API_BASE}/auth/send-code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ phone, scene: 'login' })
  })
  const result = await response.json()
  if (!response.ok || result.code !== 0) {
    throw new Error(result.msg || '验证码发送失败')
  }
  return result.data
}

export function sendRegistrationCode(phone) {
  return requestApp('/auth/send-code', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone, scene: 'register' })
  })
}

export function registerAccount(data) {
  return requestApp('/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
}

export function getInviterInfo(inviteCode) {
  return requestApp(`/h5/user/by-invite-code/${encodeURIComponent(inviteCode)}`)
}

export function getAgreementContent(key) {
  return requestApp(`/app-agreement/use/${key}`)
}

export function getAppDownloadInfo() {
  return requestApp('/h5/apk-url')
}
